import Routes from '@/constants/predefined_routes.js'

export default {
    created () {
        return {
            routes: Routes
        }
    },
    methods: {
        backstage_router_push({path, query}) {
            this.$router.push({ path: `/backstage${path}`, query })
        }
    }
}